import React, { useEffect, useRef } from 'react';
import { builderDispatch, WebUI } from '../../_utils/ui';
import { UpdatePhotoEvents } from '../common/events/event-declarations';
import screenAndStyle from '../../_utils/screen-and-style';

// Disable back button for chrome
// https://support.google.com/chrome/thread/8721521/disable-back-button-on-browser?hl=en

if (!screenAndStyle.isSafari()) {
  window.history.pushState(null, null, location.href);
  window.history.back();
  window.history.forward();
  window.window.onpopstate = function() {
    history.forward();
  };
}

export default function WithGestureActions({ backGesture, children }) {
  const defaultBackBtnActionDisabled = useRef(false);
  const disableGestureActions = useRef(false);
  const backGestureTriggerDistance = 100;
  let start;
  let end;

  useEffect(() => {
    const builderDispatchToken = builderDispatch.register(payload => {
      switch (payload.type) {
        // Mobile editor has sliders so gesture could be called by mistake
        case UpdatePhotoEvents.ADVANCED_EDIT_CLOSE:
          disableGestureActions.current = false;
          break;
        case WebUI.PHOTO_EVENT_ADVANCED_EDIT:
          disableGestureActions.current = true;
          break;
      }
    });

    return () => {
      builderDispatch.unregister(builderDispatchToken);
    };
  }, []);

  useEffect(() => {
    defaultBackBtnActionDisabled.current = true;

    return () => {
      defaultBackBtnActionDisabled.current = false;
    };
  }, []);

  useEffect(() => {
    if (screenAndStyle.isSafari()) {
      history.pushState(null, null, location.href);
      window.addEventListener('popstate', function() {
        history.pushState(null, null, location.href);
      });
    }

    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('touchend', handleTouchEnd);
    window.addEventListener('mousedown', handleMouseDown);
    window.addEventListener('mouseup', handleMouseUp);
    window.addEventListener('popstate', handleBackButtonPress);

    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchend', handleTouchEnd);
      window.removeEventListener('mousedown', handleMouseDown);
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('popstate', handleBackButtonPress);
    };
  }, []);

  function backGestureTriggered() {
    return Number(end) - Number(start) >= backGestureTriggerDistance;
  }

  function handleBackGesture() {
    if (backGestureTriggered() && !disableGestureActions.current) {
      backGesture && backGesture();
    }
  }

  function handleBackButtonPress(e) {
    e.preventDefault();

    if (
      defaultBackBtnActionDisabled.current &&
      !disableGestureActions.current
    ) {
      backGesture && backGesture();
    }
  }

  function handleMouseUp(e) {
    end = e.clientX;

    handleBackGesture();
  }

  function handleMouseDown(e) {
    start = e.clientX;
    end = 0;
  }

  function handleTouchStart(e) {
    start = e.targetTouches[0]?.clientX;
    end = 0;
  }

  function handleTouchEnd(e) {
    end = e.changedTouches[0]?.clientX;

    handleBackGesture();
  }

  return children;
}
